import httpCommon from "./http-common";

// Get all invoice items
const getAllInvoices = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/invoices/${businessId}?skip=${skip}&limit=${limit}`);
};

const getAllRecentInvoices = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/recentInvoices/${businessId}?skip=${skip}&limit=${limit}`);
};

const getInvoicesByPendingStatus = (businessId: number) => {
  return httpCommon.get(`/v1/get/invoicesByPendingStatus/${businessId}`);
};

const getInvoicesShowingOnlyStatus = (businessId: number) => {
  return httpCommon.get(`/v1/get/invoicesShowingOnlyStatus/${businessId}`);
};

// Get invoice item count
const getAllInvoicesCount = () => {
  return httpCommon.get("/v1/get/count/invoices");
};

const getInvoicesTotalValue = () => {
  return httpCommon.get("/v1/get/totalValue/invoices");
};

const getInvoiceById = (id: number) => {
  return httpCommon.get(`/v1/get/invoice/${id}`);
};

// Create invoice
const createInvoice = (data: any, businessId: number) => {
  return httpCommon.post(`/v1/add/invoice/${businessId}`, data);
};

// Update specific invoice item
const updateSpecificInvoice = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/invoice/${id}`, data);
};

// Delete invoice
const deleteInvoice = (id: number) => {
  return httpCommon.delete(`/v1/delete/invoice/${id}`);
};

// Admin functions
const getAllInvoicesAsAdminUser = (skip = 0) => {
  return httpCommon.get(`/v1/admin/get/invoices?skip=${skip}`);
};

const getAllInvoicesCountAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/count/invoices");
};

const getInvoicesTotalValueAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/totalValue/invoices");
};

const InvoiceService = {
    getAllInvoices,
    getAllRecentInvoices,
    getAllInvoicesCount,
    getInvoicesByPendingStatus,
    getInvoicesShowingOnlyStatus,
    getInvoicesTotalValue,
    getInvoiceById,
    createInvoice,
    updateSpecificInvoice,
    deleteInvoice,
    getAllInvoicesAsAdminUser,
    getAllInvoicesCountAsAdminUser,
    getInvoicesTotalValueAsAdminUser,
};
export default InvoiceService;
